import { render, staticRenderFns } from "./DesktopMainSubnavigation.vue?vue&type=template&id=4e8b7f74&"
import script from "./DesktopMainSubnavigation.vue?vue&type=script&lang=js&"
export * from "./DesktopMainSubnavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavLink: require('/vercel/path0/components/navigation/NavLink.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
